import { borderStyle } from "./tokens/border-style";
import { breakpoint } from "./tokens/breakpoint";
import { color } from "./tokens/color";
import { family } from "./tokens/family";
import { leading } from "./tokens/leading";
import { rounded } from "./tokens/rounded";
import { shadow } from "./tokens/shadow";
import { spacing } from "./tokens/spacing";
import { text } from "./tokens/text";
import { tracking } from "./tokens/tracking";
import { weight } from "./tokens/weight";
import { zIndex } from "./tokens/zIndex";

export default {
  tokens: {
    "border-style": borderStyle,
    color,
    rounded,
    shadow,
    spacing,
    family,
    leading,
    tracking,
    text,
    weight,
    breakpoint,
    zIndex,
  },
};
